// @ts-nocheck
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { ActionBar, Button, Text } from '@beef/ui-kit';

import { modalState } from 'constants/cheaperModal';

import styles from './styles.pcss';

const cx = classNames.bind({ ...styles });

export const ModalFooter = ({ step, onCloseModal, onUserLicense }) => {
  if (step === modalState.SUCCESS) {
    return (
      <ActionBar size="m" isWithText>
        <Button size="m" onClick={onCloseModal}>
          Отлично
        </Button>
      </ActionBar>
    );
  }

  if (step === modalState.FORM) {
    return (
      <ActionBar size="m" isWithText>
        <Text size="size5-r-l" color="grey50">
          Нажимая на кнопку «Отправить», я соглашаюсь с условиями обработки
          <storng onClick={onUserLicense} className={cx('personal-data-link')}>
            персональных данных
          </storng>
        </Text>
      </ActionBar>
    );
  }
};

ModalFooter.propTypes = {
  step: PropTypes.string,
  onCloseModal: PropTypes.func,
  onUserLicense: PropTypes.func,
};
